import axios from 'axios';
const adminURL = process.env.VUE_APP_ADMIN_URL;

export default class AttachmentTypesService {
  static getHeaders() {
    const token = JSON.parse(localStorage.getItem('accessToken'));
    return { Authorization: `Bearer ${token}` };
  }

  static async getAll() {
    try {
      const res = await axios.get(`${adminURL}/refund-attachment-types`, { headers: this.getHeaders() });
      return { status: 'ok', data: res.data.data ?? res.data };
    } catch (e) { return { status: 'error' }; }
  }

  static async create(data) {
    try {
      const res = await axios.post(`${adminURL}/refund-attachment-types`, data, { headers: this.getHeaders() });
      return { status: 'ok', data: res.data.data ?? res.data };
    } catch (e) { return { status: 'error', message: e.response?.data?.message }; }
  }

  static async update(id, data) {
    try {
      const res = await axios.put(`${adminURL}/refund-attachment-types/${id}`, data, { headers: this.getHeaders() });
      return { status: 'ok', data: res.data.data ?? res.data };
    } catch (e) { return { status: 'error', message: e.response?.data?.message }; }
  }

  static async remove(id) {
    try {
      await axios.delete(`${adminURL}/refund-attachment-types/${id}`, { headers: this.getHeaders() });
      return { status: 'ok' };
    } catch (e) { return { status: 'error', message: e.response?.data?.message }; }
  }
}
